module.exports = __webpack_public_path__ + "static/media/youtube_logo.8225eec1.png";